export default __webpack_public_path__ + "static/media/close.e857cdae.svg";